/**
 * Fechas “solo calendario” en DD/MM/YYYY sin desfase por zona horaria del navegador.
 * Preferimos el prefijo ISO YYYY-MM-DD (incluye cadenas que empiecen así antes de hora TZ).
 */
export function formatFechaSoloDiaDdMmYyyy(raw, emptyLabel = 'N/A') {
  if (raw == null || raw === '') return emptyLabel;
  const s = String(raw).trim();
  const head = s.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(head)) {
    const [y, mo, da] = head.split('-');
    return `${da}/${mo}/${y}`;
  }

  const t = Date.parse(s);
  if (Number.isNaN(t)) return emptyLabel;

  try {
    return new Intl.DateTimeFormat('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'America/Lima',
    }).format(new Date(t));
  } catch (_) {
    const d = new Date(t);
    return `${String(d.getUTCDate()).padStart(2, '0')}/${String(d.getUTCMonth() + 1).padStart(2, '0')}/${d.getUTCFullYear()}`;
  }
}
